import { Eye, FileText } from "lucide-react";
import { Button } from "../../../../../components/ui/button";
import { Card, CardContent } from "../../../../../components/ui/card";
import {
  SimpleColumn,
  SimpleSortableTable,
} from "../../../../../components/ui/simple-sortable-table";
import { DocumentForApproval } from "../types";

interface DocumentApprovalTableProps {
  documents: DocumentForApproval[];
  onView: (document: DocumentForApproval) => void;
}

export function DocumentApprovalTable({
  documents,
  onView,
}: DocumentApprovalTableProps) {
  const formatPhone = (phone?: string) => {
    if (!phone) return "";
    const numbersOnly = phone.replace(/\D/g, "");
    if (numbersOnly.startsWith("55") && numbersOnly.length <= 13) {
      return numbersOnly
        .replace(/^(\d{2})(\d{2})(\d)/, "+$1 ($2) $3")
        .replace(/(\d{4})(\d)/, "$1-$2");
    }
    return phone;
  };

  if (documents.length === 0) {
    return (
      <Card>
        <CardContent className="py-12">
          <div className="text-center">
            <FileText className="mx-auto h-12 w-12 text-muted-foreground mb-4" />
            <h2 className="text-xl font-semibold text-foreground">
              Não há documentos pendentes de aprovação
            </h2>
            <p className="text-muted-foreground mt-2">
              Todos os documentos foram processados
            </p>
          </div>
        </CardContent>
      </Card>
    );
  }

  const columns: SimpleColumn<DocumentForApproval>[] = [
    {
      key: "personType",
      label: "Tipo Pessoa",
    },
    {
      key: "fullName",
      label: "Nome Completo",
      sortValue: (doc) => doc.fullName || doc.nome_completo || "",
      render: (doc) => doc.fullName || doc.nome_completo || "-",
    },
    {
      key: "companyName",
      label: "Nome Empresa",
      render: (doc) => doc.companyName || "-",
    },
    {
      key: "phone",
      label: "Telefone",
      sortValue: (doc) => doc.phone || doc.telefone || "",
      render: (doc) => formatPhone(doc.phone || doc.telefone),
    },
    {
      key: "acoes",
      label: "Ações",
      sortable: false,
      headClassName: "text-right",
      cellClassName: "text-right",
      render: (doc) => (
        <Button size="sm" variant="default" onClick={() => onView(doc)}>
          <Eye className="h-4 w-4 mr-1" />
          Ver
        </Button>
      ),
    },
  ];

  return (
    <Card>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <SimpleSortableTable
            columns={columns}
            rows={documents}
            rowKey={(doc) => doc.id}
          />
        </div>
      </CardContent>
    </Card>
  );
}
